/** Default notebooks under Temas › Código — used until user customizes in /help or Hoy. */
export const DEFAULT_CODE_PROJECTS = [
  { id: "challenge-zero", label: "challenge-zero", notebookName: "challenge-zero", color: "#61DAFB", order: 0 },
  { id: "rosario-cards", label: "rosario-cards", notebookName: "rosario-cards", color: "#D4AF37", order: 1 },
  { id: "catintassist", label: "catintassist", notebookName: "catintassist", color: "#f59e0b", order: 2 },
  { id: "catreader", label: "catreader", notebookName: "catreader", color: "#a78bfa", order: 3 },
];

/** @deprecated use resolveCodeProjects */
export const CODE_PROJECTS = DEFAULT_CODE_PROJECTS;

export const CODE_PROJECT_COLORS = [
  "#61DAFB",
  "#D4AF37",
  "#f59e0b",
  "#a78bfa",
  "#4ade80",
  "#f472b6",
  "#38bdf8",
  "#fb923c",
  "#94a3b8",
  "#e879f9",
];

const STORAGE_KEY = "trufapp_code_project";
const RECENT_KEY = "trufapp_recent_code_projects";
const RECENT_MAX = 4;

export function loadRecentCodeProjectIds() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter(Boolean).slice(0, RECENT_MAX) : [];
  } catch {
    return [];
  }
}

export function touchRecentCodeProject(id) {
  if (!id) return loadRecentCodeProjectIds();
  const next = [id, ...loadRecentCodeProjectIds().filter((x) => x !== id)].slice(0, RECENT_MAX);
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function resolveRecentCodeProjects(settings = {}) {
  const all = resolveCodeProjects(settings);
  const byId = new Map(all.map((p) => [p.id, p]));
  const recent = loadRecentCodeProjectIds()
    .map((id) => byId.get(id))
    .filter(Boolean);
  if (recent.length) return recent;
  return all.slice(0, RECENT_MAX);
}

export function resolveCodeProjects(settings = {}) {
  const custom = settings?.codeProjects;
  if (!Array.isArray(custom) || custom.length === 0) {
    return DEFAULT_CODE_PROJECTS.map((p, i) => ({ ...p, order: i }));
  }
  return [...custom]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((p, i) => ({
      id: String(p.id || `proj-${i}`),
      label: String(p.label || p.notebookName || p.id || "Proyecto").trim(),
      notebookName: String(p.notebookName || p.label || p.id || "Proyecto").trim(),
      color: p.color || CODE_PROJECT_COLORS[i % CODE_PROJECT_COLORS.length],
      order: i,
    }));
}

export function getCodeProject(id, settings = null) {
  if (!id) return null;
  const list = settings ? resolveCodeProjects(settings) : DEFAULT_CODE_PROJECTS;
  return list.find((p) => p.id === id) || null;
}

export function makeProjectId(label, existing = []) {
  const base =
    String(label || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 36) || `proj-${Date.now()}`;
  const ids = new Set(existing.map((p) => p.id));
  let id = base;
  let n = 1;
  while (ids.has(id)) {
    id = `${base}-${n}`;
    n += 1;
  }
  return id;
}

export function loadCodeProjectId() {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export function saveCodeProjectId(id) {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
